import React from 'react';
import useNextStepVm from '|/app/next-step/use-next-step-vm';
import { Dashboard, Summary } from '|/app/services';

const defaultProps = {
  UpdateDashboardAndSummary: (_1: Dashboard, _2: Summary, _3: any) => {}
};

const NextStep = ({ UpdateDashboardAndSummary } = defaultProps) => {
  useNextStepVm(UpdateDashboardAndSummary);
  return <></>;
};

export default NextStep;
